import styled from 'styled-components';

const NavContainer = styled.nav`
  background: #c8102e;
  color: ${Styles.color.white};
  height: 78px;
  margin: 0 auto;
  padding: 30px;
`;

export default NavContainer;
